export default "__VITE_ASSET__CdeS5FP0__"